import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Loader from '@site/component-loader';
import { getBaseApiUrl, getAssetBucket } from './util.js';
import prefetchRecommendations from './prefetchRecommendations.js';
import React from 'react';
import PropTypes from 'prop-types';
var Recommendations = function Recommendations(props) {
  var _window3, _window3$rerec;
  console.debug('Recommendations Entry props', props);
  var baseUrl = getBaseApiUrl(props);
  var ASSET_BUCKET = getAssetBucket(props, baseUrl);
  var handleVisualComplete = function handleVisualComplete() {
    console.log('Recommendations visual complete');
  };
  var handleLoad = function handleLoad() {
    console.log('Calling handleLoad');
    try {
      var _window;
      (_window = window) === null || _window === void 0 ? void 0 : _window.rerec.loadRecommendations(props.id, _objectSpread(_objectSpread({}, props), {}, {
        handleVisualComplete: handleVisualComplete
      }));
    } catch (loadError) {
      console.error('Error loading recommendations:', loadError);
    }
  };
  var handleAssetsLoad = function handleAssetsLoad(_ref) {
    var version = _ref.version;
    var labels = {
      version: version,
      placementKey: props.placementKey,
      appKey: props.appKey,
      component: props.component
    };
    console.log('Recommendations assets loaded', labels);
  };
  var handlePrefetch = function handlePrefetch() {
    var _window2, _window2$rerec;
    console.log('Calling handlePrefetch');
    try {
      prefetchRecommendations(props);
    } catch (prefetchError) {
      console.error('Error prefetching recommendations:', prefetchError);
    }
    if (typeof window !== 'undefined' && (_window2 = window) !== null && _window2 !== void 0 && (_window2$rerec = _window2.rerec) !== null && _window2$rerec !== void 0 && _window2$rerec.loadRecommendations) {
      handleLoad();
    }
  };
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && !((_window3 = window) !== null && _window3 !== void 0 && (_window3$rerec = _window3.rerec) !== null && _window3$rerec !== void 0 && _window3$rerec.loadRecommendations)) {
    console.log('Adding event listener for recommendationsLoaded');
    document.addEventListener('recommendationsLoaded', handleLoad);
  }
  return /*#__PURE__*/React.createElement(Loader, _extends({}, props, {
    url: "".concat(baseUrl, "/v1/assets").concat(ASSET_BUCKET),
    entryKey: 'Recommendations',
    nameSpace: 'rerec',
    replaceSrcMethodName: 'getClientFiles',
    onLoad: function onLoad() {
      return document.dispatchEvent(new Event('recommendationsLoaded'));
    },
    onAssetsLoad: handleAssetsLoad,
    onPrefetch: handlePrefetch
  }));
};
Recommendations.propTypes = {
  appKey: PropTypes.string.isRequired,
  basketId: PropTypes.string,
  bucket: PropTypes.string,
  component: PropTypes.string.isRequired,
  id: PropTypes.string,
  placementKey: PropTypes.string,
  hostUri: PropTypes.string
};
export default Recommendations;
//# sourceMappingURL=Recommendations.js.map